module.exports = __webpack_public_path__ + "static/media/favorite__mix--active.1e11f1c0.svg";